import { observer } from 'mobx-react';
import { localeStore } from 'src/mobx/localesStore';
import OrderBlockHeader from 'src/view/screens/OrderScreen/components/OrderBlockHeader/OrderBlockHeader';
import OrderBlockItem from 'src/view/screens/OrderScreen/components/OrderBlockItem/OrderBlockItem';
import { useOrderStoreContext } from '~/view/screens/OrderScreen/context';
import './style.scss';

const PickupCurbsideInfo = observer(() => {
  const { store: orderStore } = useOrderStoreContext();
  if (!orderStore.order) return null;

  return (
    <div className="pickup-curbside mt-2">
      <OrderBlockHeader title="curbside" />
      <ul className="d-flex flex-column">
        <OrderBlockItem
          title="client_arrived"
          titleClassName="pickup-curbside__item-title"
          data={orderStore.order.curbside?.client_arrived ? localeStore.t('txt_yes') : localeStore.t('txt_no')}
        />
        <OrderBlockItem title="car_brand" titleClassName="pickup-curbside__item-title" data={orderStore.order.curbside?.car_brand} />
        <OrderBlockItem title="car_type" titleClassName="pickup-curbside__item-title" data={orderStore.order.curbside?.car_type} />
        <OrderBlockItem title="car_color" titleClassName="pickup-curbside__item-title" data={orderStore.order.curbside?.car_color} />
        <OrderBlockItem title="car_number" titleClassName="pickup-curbside__item-title" data={orderStore.order.curbside?.car_number} />
      </ul>
    </div>
  );
});

export default PickupCurbsideInfo;
